import { Typography } from '@/components/ui'

import { IHistoryLegendItem } from '@/types/history.interface'

const HISTORY_LEGEND_ITEMS: IHistoryLegendItem[] = [
	{
		status: 'PENDING',
		description: 'highlight is queued or being processed'
	},
	{
		status: 'STARTED',
		description: 'highlight is being processed currently'
	},
	{
		status: 'UNKNOWN',
		description:
			'no result within the timeout — generate the highlight again from the Live page'
	},
	{
		status: 'FAILURE',
		description: 'please contact technical support'
	},
	{
		status: 'SUCCESS',
		description:
			'your video and SRT files are available for downloading in the table below'
	}
]

const HistoryLegend = () => {
	return (
		<div>
			<Typography
				variant='text-large'
				className=' mt-[30px] text-[18px] text-left'
			>
				Statuses information:
			</Typography>

			<div>
				{HISTORY_LEGEND_ITEMS.map(item => (
					<Typography key={item.status} variant='text'>
						{item.status} - {item.description}
					</Typography>
				))}
			</div>
		</div>
	)
}

export default HistoryLegend
